import * as React from 'react';

import * as styles from './ShowAllNewbuildingsLink.css';

export interface IShowAllNewbuildingsLinkProps {
  onClick?(): void;
  url: string;
}

export const ShowAllNewbuildingsLink: React.FC<IShowAllNewbuildingsLinkProps> = ({ onClick, url }) => {
  return (
    <a className={styles['link']} onClick={onClick} href={url} target="_blank" rel="noopener noreferrer">
      Смотреть все ЖК от застройщика
    </a>
  );
};
